import { getDocumentQuery } from './getDocumentQuery';

export function getApplicationsDocumentsQuery(language: string) {
    return getDocumentQuery(language, 'Applications');
}
